import React from 'react';
import { Survey } from '@klp/survey/index';
import { Grid } from '@material-ui/core';
import FrontpageCards from '../components/FrontpageCards';
import { FrontpageTitle } from '../components/FrontpageTitle';

export const FrontpageGeneral = () => {
    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                <Survey />
                <FrontpageTitle />
                <FrontpageCards />
            </Grid>
        </Grid>
    );
};
